/**
 * Returns a promise for a delay in ms
 * @param {number} ms - the delay to wait
 * @returns {Promise<unknown>} a promise that will resolve after the delay
 */
export function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
}
